'use client';

import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface LanguageContextType {
    language: 'bs' | 'en';
    toggleLanguage: () => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

function setGoogTransCookie(value: string) {
    const hostname = window.location.hostname;
    document.cookie = `googtrans=${value}; path=/`;
    document.cookie = `googtrans=${value}; path=/; domain=${hostname}`;
    if (hostname !== 'localhost') {
        document.cookie = `googtrans=${value}; path=/; domain=.${hostname}`;
    }
}

function clearGoogTransCookie() {
    const hostname = window.location.hostname;
    const expired = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = `googtrans=; ${expired}; path=/`;
    document.cookie = `googtrans=; ${expired}; path=/; domain=${hostname}`;
    if (hostname !== 'localhost') {
        document.cookie = `googtrans=; ${expired}; path=/; domain=.${hostname}`;
    }
}

export function LanguageProvider({ children }: { children: ReactNode }) {
    const [language, setLanguage] = useState<'bs' | 'en'>('bs');

    useEffect(() => {
        const cookies = document.cookie.split('; ');
        const googtrans = cookies.find(c => c.startsWith('googtrans='));
        if (googtrans && googtrans.includes('/en')) {
            setLanguage('en');
        } else {
            setLanguage('bs');
        }
    }, []);

    const toggleLanguage = () => {
        if (language === 'bs') {
            setGoogTransCookie('/sr/en');
        } else {
            clearGoogTransCookie();
        }
        window.location.reload();
    };

    return (
        <LanguageContext.Provider value={{ language, toggleLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLanguage() {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}
